import * as ids from '@wix/app-definition-ids'

export const FALLBACK_APPS = [
  { id: '', appDefId: ids.WIX_NEW_STORES, type: 'Stores', level: 'preferred' },
  { id: '', appDefId: ids.WIX_BOOKINGS, type: 'Bookings', level: 'preferred' },
  { id: '', appDefId: ids.WIX_EVENTS, type: 'Events', level: 'preferred' },

  { id: '', appDefId: ids.WIX_BLOG, type: 'Blog', level: 'regular' },
  { id: '', appDefId: ids.WIX_PORTFOLIO, type: 'portfolio', level: 'regular' },
  { id: '', appDefId: ids.PRICING_PLANS, type: 'PaidPlans', level: 'regular' },
  { id: '', appDefId: ids.FORM_APP, type: 'Forms', level: 'regular' },
  { id: '', appDefId: ids.WIX_AI_CHAT_ASSISTANT, type: 'Chat', level: 'regular' },
  { id: '', appDefId: ids.INSTAGRAM_FEED_NEW, type: 'Instagram', level: 'regular' },
  { id: '', appDefId: ids.WIX_VIDEO, type: 'Video', level: 'regular' },
  { id: '', appDefId: ids.WIX_MUSIC, type: 'Music', level: 'regular' },
  { id: '', appDefId: ids.WIX_CHALLENGES, type: 'Challenges', level: 'regular' },
  { id: '', appDefId: ids.WIX_GROUPS, type: 'Groups', level: 'regular' },
  { id: '', appDefId: ids.WIX_FILE_SHARE, type: 'fileShare', level: 'regular' },
  { id: '', appDefId: ids.WIX_RESTAURANTS_TABLE_RESERVATIONS, type: 'RestaurantsReservations', level: 'regular' },
  { id: '', appDefId: ids.WIX_RESTAURANTS_ORDERS, type: 'RestaurantsOrders', level: 'regular' },
  { id: '', appDefId: ids.WIX_RESTAURANTS_MENUS_NEW, type: 'RestaurantsMenus', level: 'regular' },
  { id: '', appDefId: ids.BANDSINTOWN, type: 'BandsInTown', level: 'regular' },
]
